import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClose"];
import { useState } from 'react';
import { EnrichmentSettingsProvider } from '../EnrichmentSettingsProvider';
import { BulkEnrichmentModalContent } from './BulkEnrichmentModalContent';
import { BulkEnrichmentProvider } from './useBulkEnrichment';
import { ModalBulkProvider } from '../ModalBulk/ModalBulkProvider';
import { EnrichableObjectTypeProvider } from '../EnrichableObjectTypesProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const BulkEnrichmentModal = props => {
  const [isOpen, setIsOpen] = useState(true);
  const {
      onClose
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  const handleClose = () => {
    setIsOpen(false);
  };
  const handleCloseComplete = () => {
    onClose === null || onClose === void 0 || onClose();
  };
  const handleSuccess = () => {
    setIsOpen(false);
  };
  return /*#__PURE__*/_jsx(ModalBulkProvider, {
    children: /*#__PURE__*/_jsx(EnrichmentSettingsProvider, {
      children: /*#__PURE__*/_jsx(EnrichableObjectTypeProvider, {
        children: /*#__PURE__*/_jsx(BulkEnrichmentProvider, Object.assign({}, restProps, {
          onDone: handleSuccess,
          children: /*#__PURE__*/_jsx(BulkEnrichmentModalContent, {
            isOpen: isOpen,
            onClose: handleClose,
            onCloseComplete: handleCloseComplete
          })
        }))
      })
    })
  });
};